import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { postChannelCompensationGroups } from "store/channelStore";
import { useAppDispatch } from "store/store";
import { createTitleGroup } from "store/titleStore";

interface GroupModal {
    openModal: boolean;
    onClose: VoidFunction;
    type: "title" | "channel";
    setNewGroupId: any;
}

const NewGroupModal = ({ openModal, onClose, type, setNewGroupId }: GroupModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const [newCompGroupName, setNewCompGroupName] = useState("");

    const onAddCompensationGroup = () => {
        if (type === "channel") {
            dispatch(postChannelCompensationGroups({ name: newCompGroupName })).then((resp: any) => {
                setNewCompGroupName("");
                setNewGroupId(resp.payload.id);
                onClose();
            });
        } else {
            dispatch(createTitleGroup({ name: newCompGroupName })).then((resp: any) => {
                setNewCompGroupName("");
                setNewGroupId(resp.payload.id);
                onClose();
            });
        }
    };

    return (
        <ModalBox open={openModal} onClose={onClose} mainTitle={t("NewChannel.AddCompensationGroup")}>
            <div className="add-compensation-channel-modal">
                <div className="add-compensation-field">
                    <span>{t("NewChannel.GroupName")}</span>
                    <StyledTextField
                        value={newCompGroupName}
                        onChange={(e: any) => setNewCompGroupName(e.target.value)}
                        autoFocus
                        placeholder={t("NewChannel.GroupPlaceholder")}
                    />
                </div>
                <StyledButton disabled={!newCompGroupName} buttonType="primary" onClick={onAddCompensationGroup}>
                    {t("NewChannel.CreateGroup")}
                </StyledButton>
            </div>
        </ModalBox>
    );
};

export default NewGroupModal;
